import { useAuth } from 'react-oidc-context';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import AppShell from './layout/AppShell';
import Dashboard from './pages/Dashboard';
import Targets from './pages/Targets';
import Health from './pages/Health';
import Login from './pages/Login';
import ComingSoon from './pages/ComingSoon';
import Contacts from './pages/Contacts';
import LegacyChats from './pages/LegacyChats';
import DiscoveryCalls from './pages/DiscoveryCalls';
import MessageTemplates from './pages/MessageTemplates';
import Weekly from './pages/Weekly';

export default function App() {
  const auth = useAuth();

  if (auth.isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center text-brand-sage">
        Loading…
      </div>
    );
  }

  if (auth.error) {
    return (
      <div className="flex min-h-screen items-center justify-center text-red-600">
        Auth error: {auth.error.message}
      </div>
    );
  }

  if (!auth.isAuthenticated) {
    return <Login />;
  }

  return (
    <BrowserRouter>
      <Routes>
        <Route element={<AppShell />}>
          <Route index element={<Dashboard />} />
          <Route path="weekly" element={<Weekly />} />
          <Route path="legacy-chats" element={<LegacyChats />} />
          <Route path="contacts" element={<Contacts />} />
          <Route path="discovery-calls" element={<DiscoveryCalls />} />
          <Route path="message-templates" element={<MessageTemplates />} />
          <Route path="targets" element={<Targets />} />
          <Route path="health" element={<Health />} />
          <Route
            path="*"
            element={<ComingSoon title="Not found" slice="404" />}
          />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}